import axios from 'axios'
import proxy from '@/tools/proxy'

export default class ClientBuilder {
  constructor(axiosConfig) {
    this.advices = [];
    this.axios = axios.create(axiosConfig);
  }
  advice(advices) {
    advices = Array.isArray(advices) ? advices : [advices];
    this.advices = this.advices.concat(advices);
    return this;
  }
  build(apiConfigs) {
    let api = {};
    for (let name in apiConfigs) {
      api[name] = apiMethod.call(api, this.axios, apiConfigs[name]);
    }
    return this.advices.length > 0 ? proxy(api, this.advices) : api;
  }
}

function apiMethod(axios, apiConfig) {
  return (requestConfig) => {
    if (typeof requestConfig != 'object') {
      requestConfig = {};
    }
    let axiosConfig = {
      ...apiConfig,
      ...requestConfig,
      url: renderUrl(apiConfig.url, requestConfig.pathVariable),
    };
    return axios(axiosConfig).then(obj => obj.data);
  };
}

function renderUrl(url, vars) {
  return [url].concat((url.match(/{(\w+)}/g) || []).map(s => s.replace(/[{}]/g, ''))).reduce((url, varName) => {
    if (!vars || !vars[varName]) {
      throw new Error(`can not find pathVariable ${varName}`);
    }
    return url.replace(`{${varName}}`, vars[varName])
  });
}